var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pe_spinner"},[(_vm.type === 'cube')?_c('div',{staticClass:"pe_cube"},[_c('div',{staticClass:"pe_cube1"}),_c('div',{staticClass:"pe_cube2"})]):_vm._e(),(_vm.type === 'circle')?_c('div',{staticClass:"pe_circle"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }